import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Clock, BadgeCheck, ArrowUpRight } from "lucide-react";
import CurrencyConverter from "./CurrencyConverter";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-slate-50 to-white" data-testid="hero-section">
      {/* Decorative grid */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #0F172A 1px, transparent 1px), linear-gradient(to bottom, #0F172A 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-brand-gold/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-slate-900/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-14 lg:pt-24 pb-16 lg:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left */}
          <div className="lg:col-span-7 fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-slate-200 bg-white/80 backdrop-blur text-xs font-semibold text-slate-700 mb-6">
              <span className="live-dot" />
              B Grubu Yetkili Müessese · Canlı Piyasa Verileri
            </div>

            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-950 leading-[0.95] tracking-tighter mb-6">
              Yalova'nın <br />
              <span className="text-brand-gold italic font-light">güvenilir</span> finans <br />
              noktası.
            </h1>

            <p className="text-base md:text-lg text-slate-600 max-w-xl leading-relaxed mb-8">
              20+ yıllık tecrübemizle döviz ve altın piyasalarında şeffaf, hızlı ve güvenli işlem deneyimi sunuyoruz. Anlık piyasa verileriyle güncellenen kur tablomuzla bilinçli karar verin.
            </p>

            {/* Trust badges */}
            <div className="grid grid-cols-3 gap-4 mb-10 max-w-xl">
              {[
                { icon: <ShieldCheck className="w-5 h-5" />, t: "Canlı Veri", s: "Anlık Kurlar" },
                { icon: <Clock className="w-5 h-5" />, t: "20+ Yıl", s: "Tecrübe" },
                { icon: <BadgeCheck className="w-5 h-5" />, t: "Güvenli", s: "İşlem" },
              ].map((b, i) => (
                <div
                  key={i}
                  className="flex flex-col items-start gap-1.5 p-4 rounded-xl bg-white border border-slate-200 shadow-sm hover:border-brand-gold/40 hover:-translate-y-0.5 transition-all"
                >
                  <div className="text-brand-gold">{b.icon}</div>
                  <div>
                    <div className="text-sm font-bold text-slate-950">{b.t}</div>
                    <div className="text-[11px] text-slate-500 uppercase tracking-wider">{b.s}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#rates"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-slate-950 text-white text-sm font-semibold hover:bg-brand-gold transition-all group shadow-lg shadow-slate-950/10"
                data-testid="hero-cta-rates"
              >
                Anlık Kurları Gör
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
              </a>
              <Link
                to="/iletisim"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border border-slate-300 text-slate-950 text-sm font-semibold hover:border-slate-950 transition-all"
                data-testid="hero-cta-contact"
              >
                Bize Ulaşın
              </Link>
            </div>
          </div>

          {/* Right - Converter */}
          <div className="lg:col-span-5 fade-up delay-2">
            <CurrencyConverter />
          </div>
        </div>
      </div>
    </section>
  );
}
